package components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import form.CalculatorFormState
import form.FieldSection
import form.calculatorFieldDefinitions
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun InputPanel(
    form: CalculatorFormState,
    fieldErrors: Map<String, String>,
    onFormChange: (CalculatorFormState) -> Unit,
) {
    var collapsedSections by remember {
        mutableStateOf(initialCollapsedSections(emptySet()))
    }
    val sectionsWithErrors = calculatorFieldDefinitions
        .filter { fieldErrors.containsKey(it.key) }
        .mapTo(mutableSetOf()) { it.section }
    LaunchedEffect(sectionsWithErrors) {
        collapsedSections = collapsedSections - sectionsWithErrors
    }

    Div({ classes("panel", "inputs-panel") }) {
        H2 { Text("Вводные параметры") }
        Div({ classes("input-grid") }) {
            FieldSection.entries.forEach { section ->
                val collapsed = section in collapsedSections
                Div({ classes("input-section-group") }) {
                    Button({
                        classes("input-section-toggle")
                        attr("aria-expanded", (!collapsed).toString())
                        onClick {
                            collapsedSections = if (collapsed) {
                                collapsedSections - section
                            } else {
                                collapsedSections + section
                            }
                        }
                    }) {
                        Span { Text(section.title) }
                        Span({ classes("input-section-chevron") }) { Text(if (collapsed) "+" else "-") }
                    }
                    Div({
                        classes("input-section-fields")
                        if (collapsed) classes("input-section-fields-collapsed")
                    }) {
                        calculatorFieldDefinitions
                            .filter { it.section == section && it.key != "apecCardCostRub" && !it.key.startsWith("eVisa") }
                            .forEach { field ->
                                NumberField(
                                    label = field.label,
                                    suffix = field.suffix,
                                    helpText = field.helpText,
                                    currentValue = form.value(field.key),
                                    error = fieldErrors[field.key],
                                    onChange = { onFormChange(form.update(field.key, it)) },
                                )
                            }
                    }
                }
            }
        }
    }
}

internal fun initialCollapsedSections(sectionsWithErrors: Set<FieldSection>): Set<FieldSection> {
    return FieldSection.entries.toSet() - sectionsWithErrors
}
